/*
 * @Description:
 * @Date: 2024-01-17 17:56:35
 */
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';

import titleCmpts from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-title';
import pageNoCmpts from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-page-number';
import subTitles from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-sub-title';

import { isObject } from '@/utils/is';
import { useBiTmplDetailSteup } from '@V/bi-tmpl/src/store';
import { SCENE_MAPPING } from '../constants/index';

export const useRouteQuery = () => {
  const route = useRoute();
  const query = route.query as {
    id?: string;
    sceneType?: keyof typeof SCENE_MAPPING;
    type?: 'add' | 'edit' | 'check';
  }; // id新增无值，type新增 编辑 查看
  const isCheck = query.type === 'check';
  return {
    query,
    isCheck
  };
};

// 设置通用，菜单为当前激活
export const useDetailCmpt = (params?: { childKey?: string }) => {
  const { childKey } = params || {};
  const store = useBiTmplDetailSteup();
  const { state } = storeToRefs(store);
  const { isCheck } = useRouteQuery();
  const curItem = store.getCurSetItem(childKey);

  // 查看与不展示禁止操作
  const notHandler = computed(() => {
    return isCheck || !curItem.show;
  });
  const onChange = val => {
    if (notHandler.value) return;
    store.setMenuValue(Array.isArray(val) ? val.join(',') : val, childKey);
  };
  const onClear = () => {
    store.setMenuValue('', childKey);
  };
  // 分组，n个一组
  const group = (mapping, n = 2) => {
    const arr = [];
    Object.values(mapping).forEach((item, index) => {
      if (index % n === 0) {
        !index ? (arr[0] = []) : (arr[arr.length] = []);
      }
      arr[arr.length - 1].push(item);
    });
    return arr;
  };
  const titleCmpt = computed(() => {
    const cmptName = state.value.menuValue.get('101').value['101_2'].value;
    return titleCmpts.find(item => item.__name === cmptName);
  });
  const pageNoCmpt = computed(() => {
    const cmptName = state.value.menuValue.get('101').value['101_4'].value;
    return pageNoCmpts.find(item => item.__name === cmptName);
  });
  const subTitleCmpt = computed(() => {
    const cmptName = state.value.menuValue.get('101').value['101_3'].value;
    return subTitles.find(item => item.__name === cmptName);
  });
  return {
    store,
    state,
    curItem,
    onChange,
    onClear,
    group,
    titleCmpt,
    pageNoCmpt,
    subTitleCmpt,
    notHandler
  };
};

/**
 * @description: 递归检查是否设置完毕
 * @param {*} menu 当前菜单
 * @return {boolean} 0未设置 1已设置 2不展示(算完成设置)
 */

export const checkValueDone = menu => {
  let done = 1;
  // object类型为有子集：任一展示中的子集未设置则父级未设置。
  // 不展示(2)算完成，不能用最后一个子集的 2 覆盖前面已设置的 1。
  if (isObject(menu.value)) {
    for (const i of Object.values(menu.value)) {
      const childDone = checkValueDone(i);
      if (!childDone) {
        done = 0;
        break;
      }
    }
  }
  // 设置展示并且没值计为不可下一步
  if (!menu.value && menu.show) {
    done = 0;
  }

  // 示例分享，项目执行流程，不需要设置
  if (['EXAMPLE_SHARING', 'PROJECT_EXE_FLOW'].includes(menu.modelType)) {
    done = 1;
  }

  // 项目参与人完成的任务区间分布
  if (menu.modelType === 'PROJECT_EXE_STAT_INTERVAL') {
    // 百分比分析、中位数、众数、四分位数分析，选一个即可
    if (
      (menu.value['4_3_2'].value || menu.value['4_3_3'].value) &&
      menu.value['4_3_1'].value
    ) {
      done = 1;
    }
  }

  // 项目执行人数统计
  if (menu.modelType === 'PROJECT_RESEARCH') {
    // 百分比分析、中位数、众数、四分位数分析，选一个即可
    if (
      (menu.value['5_3'].value || menu.value['5_4'].value) &&
      menu.value['5_2'].value &&
      menu.value['5_1'].value
    ) {
      done = 1;
    }
  }

  if (!menu.show) {
    done = 2;
  }

  // 水印不显示，计为已设置
  if (menu.modelType === 'BASIC_STYLE_WATERMARK' && !menu.show) {
    done = 1;
  }

  return done;
};
